// Base class for all connection states
export abstract class ConnectionState {}

// Individual connection state classes
export class Disconnected extends ConnectionState {
  statusCode?: number;
  reason?: string;

  constructor(statusCode?: number, reason?: string) {
    super();
    this.statusCode = statusCode;
    this.reason = reason;
  }
}

export class Connecting extends ConnectionState {}

export class Connected extends ConnectionState {
  isFirstConnection: boolean;

  constructor(isFirstConnection: boolean) {
    super();
    this.isFirstConnection = isFirstConnection;
  }
}

export class ConnectionError extends ConnectionState {}
